import { Project } from '../types';
import { MEPManager } from './MEPManager';

export interface SystemBrowserNode {
    id: string;
    label: string;
    type: 'System' | 'Equipment' | 'Terminal';
    children?: SystemBrowserNode[];
    flow?: number;
    pressure?: number;
}

export class SystemBrowser {
    constructor(private manager: MEPManager, private project: Project) { }

    getTree(): SystemBrowserNode[] {
        const rootNodes: SystemBrowserNode[] = [];

        // Group by Classification logic could go here (Supply vs Return folders)
        // For now, flat list of systems.

        // Access private systems map via 'any' or provide public accessor
        // Adding accessor to MEPManager is better but for now casting.
        const systems = this.manager.getAllSystems();

        systems.forEach(system => {
            const systemNode: SystemBrowserNode = {
                id: system.id,
                label: system.name,
                type: 'System',
                children: []
            };

            // Build hierarchy: Equipment -> [Ducts] -> Terminals
            // Flattened for browser: List equipment and terminals.

            system.elementIds.forEach(elId => {
                const el = this.project.elements.get(elId);
                if (el) {
                    if (el.category === 'Mechanical Equipment') {
                        systemNode.children?.push({
                            id: el.id,
                            label: `Equipment: ${el.parameters['Family Name'] || el.id}`,
                            type: 'Equipment'
                        });
                    } else if (el.category === 'Air Terminals') {
                        // Get flow from logic to be accurate
                        // logic.nodes.get(elId).flow is 'Demand'.
                        // Actual flow supplied might be different if we implemented balancing.
                        // For now show param flow.
                        const flow = el.parameters['Flow'] || 0;

                        systemNode.children?.push({
                            id: el.id,
                            label: `Terminal: ${el.id}`,
                            type: 'Terminal',
                            flow: flow
                        });
                    }
                }
            });

            rootNodes.push(systemNode);
        });

        return rootNodes;
    }
}
